import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import MainButtonVue from '@/components/buttons/MainButtonVue';
import HeaderVue from '@/components/HeaderVue';
import BackButton from '@/components/buttons/BackButton.vue';
import CheckboxVue from '@/components/buttons/CheckboxVue.vue';
import ModalVue from '@/components/modals/ModalVue.vue'
import AppTitle from "@/components/AppTitle";

Vue.config.productionTip = false

const app = new Vue({
  router,
  store,
  render: h => h(App)
})


import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

Vue.component('main-button', MainButtonVue)
Vue.component('header-vue', HeaderVue)
Vue.component('back-button', BackButton)
Vue.component('checkbox-vue', CheckboxVue)
Vue.component('modal-vue', ModalVue)
Vue.component('app-title', AppTitle)

app.$mount('#app')